export default __webpack_public_path__ + "static/ourPartner2-f23aedccb84429bb3f677a2f228c7f16.png";